<template>
  <!-- 填充 -->
  <AttrImage
    label="预览图"
    class="mt-2.5"
    :base64="preview"
    :disabled="attrDisabled == 'not-image'"
    @change="(image: string) => onImageUpdate(image,'apkPreview')"
    @delete="() => onImageDelete('apkPreview')"
  />

  <UploadDirectory
    label="上传文件夹"
    class="mt-2.5"
    :dirname="dirname"
    :disabled="!!attrDisabled"
    :tooltip="tooltip"
    @upload="onUploadDir"
    @delete="onDeleteDir"
  />

  <!-- 图片输出格式 -->
  <div>
    <AttrImgFomat :shape="shape" />
  </div>
</template>

<script lang="ts" setup>
import { PropType, computed } from 'vue';
import { Shape } from '@/services/shape';
import { ResourceKey } from '@/services/shape/attributes';
import { ElectronApi } from '@/services/electron.api';
import { useEditorStore } from '@/store/use-editor-store';
import { pickDir } from '@/utils/fs/pick-file.utils';
import { WatchfaceService } from '@/services/watchface';
import { Modal } from 'ant-design-vue';
import { emptyDir } from '@/utils/fs/fs-extra.utils';
// import { useWatchfaceAndroid } from '@/hooks';
import { useWatchfaceStore } from '@/store/use-watchface-store';

const editorStore = useEditorStore();
const attrDisabled = computed(() => editorStore.attrDisabled);
// const { androidWatcfaceOS } = useWatchfaceAndroid();
const watchStore = useWatchfaceStore();

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  }
});

const fileName = computed(() =>
  ['O61', 'Q61'].includes(watchStore.deviceType) ? 'apk' : 'rpk'
);

const tooltip = computed(() => {
  // const fileName = androidWatcfaceOS.value == 'android' ? 'apk' : 'rpk';
  return `文件夹要包含2个文件，${fileName.value}、${fileName.value}_info.json`;
});

const preview = computed(() => {
  const _preview = props.shape.getResources({
    resourceName: 'apkPreview',
    colorGroup: editorStore.themeColor?.id ?? '',
    base64: true
  });
  return _preview?.[0] ?? '';
});

const onImageUpdate = async (image: string, resourceName: ResourceKey) => {
  props.shape?.uploadResource(
    {
      resourceName,
      colorGroup: editorStore.themeColor?.id ?? '',
      realpath: image
    },
    true
  );
};

const onImageDelete = async (resourceName: ResourceKey) => {
  props.shape?.deleteResource({
    resourceName,
    colorGroup: editorStore.themeColor?.id ?? ''
  });
};

const onDeleteDir = async () => {
  let dir = dirname.value;
  dir = ElectronApi.path?.join(new WatchfaceService().ResourcePath, dir ?? '');
  if (dir) {
    await ElectronApi.fs?.promises.rm(dir, { recursive: true, force: true });
  }

  props.shape.setAttrs({
    apkFilename: '',
    apkInfoName: ''
  });
};

const dirname = computed(() => {
  const parts = props.shape.attrs.apkFilename?.split('/') ?? [];
  parts.pop();
  return parts.pop();
});

const onUploadDir = async () => {
  const fs = ElectronApi.fs;
  const path = ElectronApi.path;
  const dir = (await pickDir()) as string | undefined;
  const folder = new WatchfaceService();
  // 未选择时，不可添加
  if (!dir || !fs || !path) return;
  // 获取文件
  let _file = (await fs.promises.readdir(dir)).filter((item) => {
    const _item = item.toLowerCase();
    return _item.endsWith(fileName.value) || _item.endsWith('_info.json');
  });
  if (!_file || _file.length != 2) {
    Modal.warning({
      title: '无法上传',
      content: `文件上传失败，文件夹要包含2个文件，${fileName.value}、${fileName.value}_info.json`,
      okText: '知道了'
    });
    return;
  }

  const newDistName = `_${fileName.value}`;
  // 将用户选择的文件全部复制
  const dest = path.join(folder.ResourcePath, newDistName);
  await emptyDir(dest);
  await fs.promises.cp(dir, dest, {
    recursive: true,
    force: true
  });
  _file.map((_item) => {
    if (_item.endsWith(fileName.value)) {
      props.shape.setAttrs({
        apkFilename: [newDistName, _item].join('/')
      });
    } else if (_item.endsWith('_info.json')) {
      props.shape.setAttrs({
        apkInfoName: [newDistName, _item].join('/')
      });
    }
  });
};
</script>
